import { z } from 'zod';

/**
 * Although Prisma exposes SessionFeedbackIssue via $Enums, it is not reliably available
 * in all environments, it is defined manually here to ensure access.
 */
export const sessionFeedbackIssueSchema = z.enum([
  'Extremely_noisy',
  'Constantly_late',
  'Strong_behavior_issues',
  'Audio_issues',
  'Video_issues',
  'Connection_issues',
  'Other_tech_issues',
  'Too_easy',
  'Too_hard',
  'late',
  'left_early',
  'tech_issue',
  'disruptive_or_disrespectful',
  'extreme_concerns',
  'other',
]);
export type SessionFeedbackIssue = z.infer<typeof sessionFeedbackIssueSchema>;
export const SessionFeedbackIssue = sessionFeedbackIssueSchema.enum;

/** Issues in the class-feedback "Student issues" group, in form order. */
export const studentSessionFeedbackIssues = [
  SessionFeedbackIssue.late,
  SessionFeedbackIssue.left_early,
  SessionFeedbackIssue.tech_issue,
  SessionFeedbackIssue.Strong_behavior_issues,
] as const satisfies readonly SessionFeedbackIssue[];

/** Student issues actually recorded on a session. Omits other feedback issues such as lesson difficulty. */
export function recordedStudentSessionIssues(issues: readonly SessionFeedbackIssue[]): SessionFeedbackIssue[] {
  return studentSessionFeedbackIssues.filter((issue) => issues.includes(issue));
}
